import { observer } from "mobx-react";
import { AgvCard } from "../components/agv-card";
import { LogItem } from "../components/log-item";
import { MissionCard } from "../components/mission-card";
import { logs } from "../data";
import { Scene } from "../scene/scene";
import { store } from "../../store";
import type { Mode } from "../../domain/services/service-agv";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export const MapView = (): JSX.Element => {
    return (
        <div className="flex h-full flex-1 overflow-hidden border-t border-gray-200">
            <MapSidebar />
            <Scene />
        </div>
    );
};

export const MapSidebar = observer((): JSX.Element => {
    const { mode } = store.serviceAgv;

    return (
        <div className="flex w-80 flex-col border-r border-gray-200 bg-white">
            <Tabs
                className="flex h-full grow flex-col"
                value={mode}
                onValueChange={(value) => store.serviceAgv.setMode(value as Mode)}
            >
                <div className="p-2">
                    <TabsList className="grid w-full grid-cols-3">
                        <TabsTrigger value="vehicles">Vehicles</TabsTrigger>
                        <TabsTrigger value="missions">Missions</TabsTrigger>
                        <TabsTrigger value="logs">Logs</TabsTrigger>
                    </TabsList>
                </div>
                <TabsContent value="vehicles" className="mt-0 h-full overflow-auto">
                    <VehiclesTabContent />
                </TabsContent>
                <TabsContent value="missions" className="mt-0 h-full overflow-auto">
                    <MissionsTabContent />
                </TabsContent>
                <TabsContent value="logs" className="mt-0 h-full overflow-auto">
                    <LogsTabContent />
                </TabsContent>
            </Tabs>
        </div>
    );
});

const VehiclesTabContent = observer((): JSX.Element => {
    const { agvs } = store.serviceAgv;

    return (
        <div className="flex-1 space-y-2 overflow-y-auto px-2">
            {agvs.map((agv) => (
                <AgvCard key={agv.id} agv={agv} />
            ))}
        </div>
    );
});

const MissionsTabContent = observer((): JSX.Element => {
    const { missions, agvs } = store.serviceAgv;

    return (
        <div className="flex-1 space-y-2 overflow-y-auto px-2">
            {missions.map((m) => (
                <MissionCard
                    key={m.id}
                    mission={m}
                    agvs={agvs.filter((agv) => agv.currentMissionId === m.id)}
                />
            ))}
        </div>
    );
});

const LogsTabContent = (): JSX.Element => {
    return (
        <div className="flex-1 space-y-2 overflow-y-auto px-2">
            {logs.map((log) => (
                <LogItem key={log.id} log={log} />
            ))}
        </div>
    );
};
